/**************************************************
 * Nombre:       Seccion_Movimientos_Usuario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_COMPARACION,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ArrowBack, CloudDone, FiberManualRecord, LocalActivity, ManageSearch, Star, Wallet} from "@mui/icons-material";
import {TIPOSCONTRATO} from "../../Constantes";
import {reducirHash} from "../../CodNegocio/Funciones/reducirHash";
import {useParams} from "react-router-dom";
import {where} from "firebase/firestore";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Dialogo_Movimientos_Crear from "../Dialogos/Dialogo_Movimientos_Crear";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import {arrConteoColSemanasAtrasWhereSuma} from "../../Servicios/BD/Contadores_Arr/arrConteoColSemanasAtrasWhereSuma";
import Tarjeta_Valor_Titulo_Grafica from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Valor_Titulo_Grafica";
import Dona_Limpia from "../../Modulo_Graficas/Graficas/Dona_Limpia";
import {contarWheresSuma} from "../../Servicios/BD/Contadores/contarWheresSuma";
import {formatoMonedaGraficas} from "../../Modulo_Graficas/Utilidades/formatoMonedaGraficas";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import ic_cartera from '../../Modulo_Graficas/RecursosGraficas/ic_cartera.svg'
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {idACorreo} from "../../CodNegocio/Funciones/idACorreo";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {obtenerTotalDepositos} from "../../CodNegocio/Depositos/obtenerTotalDepositos";
import {obtenerTotalRendimientos} from "../../CodNegocio/Rendimientos/obtenerTotalRendimientos";
import {obtenerTotalBonos} from "../../CodNegocio/Bonos/obtenerTotalBonos";
import {obtenerTotalPuntos} from "../../CodNegocio/Puntos/obtenerTotalPuntos";
import {obtenerMembresia} from "../../CodNegocio/Membresia/obtenerMembresia";
import {formatoFechaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoFechaTabla";


const Seccion_Movimientos_Usuario = () => {
    const params = useParams();
    const refe = useRef()
    const altoGraficas = 200
    const {alto} = useObtenerAlto({contenedor: refe})

    const [wheres, setWheres] = useState([where('idUsuario', '==', 'none')]);
    const {
        props,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres: wheres, nombreEstado: 'tipo'});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Movimientos_Crear,
        titulo: 'Creando Movimiento',
        realizado: cargarNuevamente
    })
    const [numContratos, setNumContratos] = useState(0)
    const [totalDeposito, setTotalDeposito] = useState(0)
    const [totalRendimientos, setTotalRendimientos] = useState(0)
    const [totalBonos, setTotalBonos] = useState(0)
    const [totalPuntos, setTotalPuntos] = useState(0)
    const [fechaMembresia, setFechaMembresia] = useState({})

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }





    const obtenerDatos = async (id) => {

        let totDepositos = await obtenerTotalDepositos(id)
        setTotalDeposito(totDepositos)

        let totRendimientos = await obtenerTotalRendimientos(id)
        setTotalRendimientos(totRendimientos)

        let totalBonos = await obtenerTotalBonos(id)
        setTotalBonos(totalBonos)

        let totalPuntos = await obtenerTotalPuntos(id)
        setTotalPuntos(totalPuntos)

        let membresia =await obtenerMembresia(id)
        setFechaMembresia(membresia)





    }


    useEffect(() => {

        if (params.id) {


            let id = params.id

            let w = [where('idUsuario', '==', id)]
            setWheres(w)

           /* obtenerDoc('contratos', id).then((dox) => {
                if (dox.res) {
                    setNumContratos(dox.data)
                }
            })*/

           let wContrato = [where('idUsuario', '==', id)]
            contarWheres({coleccion: 'contratos', wheres: wContrato}).then((dox) =>{
                setNumContratos(dox.data)
            })

            obtenerDatos(id).then()

        }

    }, [params]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -3, mb: -3}}>
                    <Button
                        onClick={() => window.history.back()}
                        variant={'text'} startIcon={<ArrowBack/>}>Atras</Button>
                </Grid>


                <Grid container size={{xs: 6, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Indicador
                        titulo={'Wallet deposito'}
                        valor={formatoMonedaTabla(totalDeposito,2)}
                        Icono={Wallet}
                        icono={ic_cartera}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Indicador
                        titulo={'Contratos Activos'}
                        valor={numContratos}
                        icono={ic_cartera}/>
                </Grid>


                <Grid container size={{xs: 6, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Indicador
                        titulo={'Rendimientos'}
                        Icono={CloudDone}
                        valor={formatoMonedaTabla(totalRendimientos, 2)}
                        icono={ic_cartera}/>
                </Grid>


                <Grid container size={{xs: 6, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Indicador
                        titulo={'Bonos'}
                        Icono={LocalActivity}
                        valor={formatoMonedaTabla(totalBonos, 2)}
                        icono={ic_cartera}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Indicador
                        titulo={'Puntos'}
                        Icono={FiberManualRecord}
                        valor={totalPuntos}
                        icono={ic_cartera}/>
                </Grid>

                <Grid ref={refe} container size={{xs: 6, sm: 12, md: 2}} sx={{height: altoGraficas}}>
                    <Tarjeta_Indicador
                        titulo={'Membresia'}
                        Icono={Star}
                        valor={formatoFechaTabla(fechaMembresia)}
                        icono={ic_cartera}/>
                </Grid>





                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Movimientos Usuario (${idACorreo(params.id)})`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                       // clickAgregar={agregarMovimiento}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Movimientos_Usuario

const filtros = [
    {
        nombre: 'Valor',
        direccion: 'desc',
        propiedad: 'valor'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y tipo',
        direccion: 'left',
        propiedades: ['consecutivo', 'tipo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: "correo",
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        titulo: 'moneda',
        siTitulo: 'PUNTOS',
        tipo: CASILLA_COMPARACION

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        titulo: 'visible',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Tipo',
        direccion: 'right',
        propiedad: 'tipo',
        tipo: CASILLA_ESTADO,
        estados: [TIPOSCONTRATO[0], TIPOSCONTRATO[1]]
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]